import { StudentListCategoriesAdmin } from '@features/student-lists/components/StudentListCategoriesAdmin'
import { actualStaffRolesQueryOptions } from '@features/staff-roles/queries'
import { canAccessPortalAdministration } from '@features/portal-administration/access'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/admin/student-lists')({
  beforeLoad: async ({ context }) => {
    const roles = await context.queryClient.ensureQueryData(actualStaffRolesQueryOptions())
    if (!canAccessPortalAdministration(roles)) throw redirect({ to: '/home' })
  },
  component: StudentListCategoriesAdmin,
  staticData: { crumb: { label: 'Student Lists' } },
})
